import { Box, SvgIcon, Typography } from '@frontierag/frontier-ui-library';
import Tractor from 'images/tractor.svg?react';

export default function NoOrdersFound({ message }) {
  return (
    <Box
      position="absolute"
      left={0}
      right={0}
      top="50%"
      height={175}
      mt={'-50px'}
      data-testid="no-orders-found"
    >
      <Box display="flex" justifyContent="center" flexDirection="column">
        <Box display="flex" justifyContent="center" pb={5}>
          <SvgIcon
            component={Tractor}
            data-testid="tractor-icon"
            inheritViewBox={true}
            sx={{ width: 'auto', height: '100%', color: 'primary.main' }}
          />
        </Box>
        <Typography textAlign="center" variant="subtitle2">
          {message}
        </Typography>
      </Box>
    </Box>
  );
}
